import { render, staticRenderFns } from "./profileParents.vue?vue&type=template&id=3479ce30&scoped=true&"
import script from "./profileParents.vue?vue&type=script&lang=js&"
export * from "./profileParents.vue?vue&type=script&lang=js&"
import style0 from "./profileParents.vue?vue&type=style&index=0&id=3479ce30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479ce30",
  null
  
)

export default component.exports